import { useAutoneTranslation } from '@autone/translations';
import {
  createColumnLoadingGuards,
  DataTableCellContent,
  DataTableCellDate,
  DataTableCellTitle,
  type DataTableLoadingObject,
} from '@autone/ui';
import { type ColumnHelper } from '@tanstack/react-table';

import { type APP_NAME } from '../../../../consts';

const COLUMN_ID = 'assorted_start_date' as const;

export type ScheduledStartDateColumnId = typeof COLUMN_ID;

interface ScheduledStartDate {
  assorted_start_date: string | null;
}

const { columnCellGuard, accessorFnGuard } =
  createColumnLoadingGuards<ScheduledStartDate>();

export const createScheduledStartDateColumn = <
  T extends ScheduledStartDate | DataTableLoadingObject,
>(
  columnHelper: ColumnHelper<T>,
) =>
  columnHelper.accessor(
    accessorFnGuard((row) => row.assorted_start_date),
    {
      id: COLUMN_ID,
      size: 200,
      header: function FirstScheduledStartDateHeader() {
        const { t } = useAutoneTranslation<typeof APP_NAME>();

        return (
          <DataTableCellContent align="right">
            <DataTableCellTitle className="uppercase font-medium whitespace-normal">
              {t('table-columns.scheduled-assortment-start')}
            </DataTableCellTitle>
          </DataTableCellContent>
        );
      },
      cell: (ctx) =>
        columnCellGuard({
          ctx,
          renderCell: function FirstScheduledStartDateCell({ getValue }) {
            return (
              <DataTableCellContent align="right">
                <DataTableCellTitle>
                  <DataTableCellDate value={getValue()} />
                </DataTableCellTitle>
              </DataTableCellContent>
            );
          },
        }),
    },
  );
